var alvac = {};
jQuery( function () {
    alvac.button.init();
    alvac.carousel.init();
    alvac.linkHover.init();
} );
alvac.linkHover = {
    init: function ( ) {
        var intWindowWidth = jQuery( window ).width();
        if ( intWindowWidth > e4.settings.breakpoint.lg ) {
            document.querySelectorAll( '.js-e-nav .nav-item .nav-link .e-nav-pagename, a.btn, button.btn, a.arrow-right' ).forEach( link => {
                link.innerHTML = '<div><span>' + link.textContent.trim().split( '' ).join( '</span><span>' ) + '</span></div>'
                link.querySelectorAll( 'span' ).forEach( s => s.innerHTML = s.textContent == ' ' ? '&nbsp;' : s.textContent )
            } );
        }
    }
}
alvac.carousel = {
    init: function () {

        var alvacCarousel = jQuery('div[id*="alvac-custom-carousel-"]');

        alvacCarousel.on('slide.bs.carousel', function (e) {

            /*
                CC 2.0 License Iatek LLC 2018
                Attribution required
            */
            var $e = jQuery(e.relatedTarget);
            var idx = $e.index();
            var itemsPerSlide = 5;
            var totalItems = jQuery('.carousel-item').length;

            if (idx >= totalItems-(itemsPerSlide-1)) {
                var it = itemsPerSlide - (totalItems - idx);
                for (var i=0; i<it; i++) {
                    // append slides to end
                    if (e.direction=="left") {
                        jQuery('.carousel-item').eq(i).appendTo('.carousel-inner');
                    }
                    else {
                        jQuery('.carousel-item').eq(0).appendTo('.carousel-inner');
                    }
                }
            }
        });
    }
};
alvac.button = {
    init: function () {
        jQuery( '.btn' ).each( function ( intIndex, domElement ) {
            var buttonText = jQuery( domElement ).text();
            jQuery( domElement ).attr( 'data-before', buttonText );
        } );
    }
};
